import { FC } from 'react';

import { Text } from '@bonusly/design-system';

import { useCounterTooltipText } from './hooks/use-counter-tooltip-text';
import { useReactionContext } from './reaction-detail-context';
import { ReactionType } from './types';

type Props = {
	type: ReactionType;
	coin: FC;
};

export const ReactionStackTooltip = (reaction: Props) => {
	const { bonus } = useReactionContext();
	const text = useCounterTooltipText(bonus, reaction.type);

	return (
		<>
			<Text as="b" fontSize="sm" textTransform="capitalize">
				{reaction.type}
			</Text>
			<br />
			{text}
		</>
	);
};
